import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Typography, Alert, IconButton, Skeleton } from "@mui/material";
import { Sync } from "@mui/icons-material";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { useSnackbar } from "notistack";

const GridItem = (props) => {
  return (
    <Alert
      severity={props.isLoading ? "" : props.variant}
      icon={false}
      variant={"filled"}
      action={
        props.isLoading ? (
          <Skeleton width={30} height={30} variant="rounded" />
        ) : (
          <Typography sx={{ marginRight: "12px", marginTop: "6px" }}>
            {props.count}
          </Typography>
        )
      }
    >
      {props.isLoading ? (
        <Skeleton width={250} />
      ) : (
        <Typography>{props.title}</Typography>
      )}
    </Alert>
  );
};

const metaData = {
  Status0: {
    title: "نزد لابراتوار",
    variant: "info",
  },
  Status1: {
    title: "نزد پزشک",
    variant: "info",
  },
  Status2: {
    title: "تمام شده",
    variant: "success",
  },
  late: {
    title: "دیر شده",
    variant: "error",
  },
  forToday: {
    title: "ارسال امروز",
    variant: "warning",
  },
  forTommorow: {
    title: "ارسال فردا",
    variant: "primary",
  },
  forTwoDays: {
    title: "دو روز دیگر",
    variant: "primary",
  },
  forThreeDays: {
    title: "سه روز دیگر",
    variant: "primary",
  },
  notLate: {
    title: "وقت دارد",
    variant: "primary",
  },
  pending: {
    title: "در انتظار قطعه",
    variant: "primary",
  },
};

const SummarySection = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    Status0: null,
    Status1: null,
    Status2: null,
    late: null,
    forToday: null,
    forTommorow: null,
    forTwoDays: null,
    forThreeDays: null,
    notLate: null,
    pending: null,
  });
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const getData = async () => {
    setIsLoading(true);
    await axios
      .post("/api/v1/laboratorys/get-dashboard-info", undefined, {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth.token,
        },
      })
      .then((response) => setData(response.data.data))
      .catch((e) => {
        const messages = e.response.data.data;
        messages.map((message) =>
          enqueueSnackbar(message, { variant: "error" })
        );
      });
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={4}
      alignItems={"flex-start"}
    >
      <Grid
        container
        width={"100%"}
        spacing={4}
        p={0}
        justifyContent={"space-between"}
      >
        <Grid>
          <Typography component={"h5"} variant="h5">
            خلاصه وضعیت کارها
          </Typography>
        </Grid>
        <Grid px={0}>
          <IconButton
            size="small"
            onClick={getData}
            aria-label="refetch dashboard summary"
          >
            <Sync fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container width={"100%"} spacing={2} p={0}>
        {Object.keys(data).map((d, i) => (
          <Grid xs={12} md={6} key={i}>
            <GridItem
              count={data[d]}
              title={metaData[d].title}
              variant={metaData[d].variant}
              isLoading={isLoading}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SummarySection;
